module.exports=[
  {
    "County": "Adams",
    "pop_2020": 20450
  },
  {
    "County": "Asotin",
    "pop_2020": 22640
  },
  {
    "County": "Benton",
    "pop_2020": 205700
  },
  {
    "County": "Chelan",
    "pop_2020": 79660
  },
  {
    "County": "Clallam",
    "pop_2020": 76770
  },
  {
    "County": "Clark",
    "pop_2020": 499200
  },
  {
    "County": "Columbia",
    "pop_2020": 4185
  },
  {
    "County": "Cowlitz",
    "pop_2020": 110500
  },
  {
    "County": "Douglas",
    "pop_2020": 43750
  },
  {
    "County": "Ferry",
    "pop_2020": 7910
  },
  {
    "County": "Franklin",
    "pop_2020": 96760
  },
  {
    "County": "Garfield",
    "pop_2020": 2225
  },
  {
    "County": "Grant",
    "pop_2020": 100130
  },
  {
    "County": "Grays Harbor",
    "pop_2020": 74720
  },
  {
    "County": "Island",
    "pop_2020": 85530
  },
  {
    "County": "Jefferson",
    "pop_2020": 32190
  },
  {
    "County": "King",
    "pop_2020": 2260800
  },
  {
    "County": "Kitsap",
    "pop_2020": 272200
  },
  {
    "County": "Kittitas",
    "pop_2020": 48140
  },
  {
    "County": "Klickitat",
    "pop_2020": 22770
  },
  {
    "County": "Lewis",
    "pop_2020": 80250
  },
  {
    "County": "Lincoln",
    "pop_2020": 11050
  },
  {
    "County": "Mason",
    "pop_2020": 65650
  },
  {
    "County": "Okanogan",
    "pop_2020": 43130
  },
  {
    "County": "Pacific",
    "pop_2020": 21840
  },
  {
    "County": "Pend Oreille",
    "pop_2020": 13850
  },
  {
    "County": "Pierce",
    "pop_2020": 900700
  },
  {
    "County": "San Juan",
    "pop_2020": 17340
  },
  {
    "County": "Skagit",
    "pop_2020": 130450
  },
  {
    "County": "Skamania",
    "pop_2020": 12220
  },
  {
    "County": "Snohomish",
    "pop_2020": 830500
  },
  {
    "County": "Spokane",
    "pop_2020": 522600
  },
  {
    "County": "Stevens",
    "pop_2020": 45920
  },
  {
    "County": "Thurston",
    "pop_2020": 291000
  },
  {
    "County": "Wahkiakum",
    "pop_2020": 4210
  },
  {
    "County": "Walla Walla",
    "pop_2020": 62580
  },
  {
    "County": "Whatcom",
    "pop_2020": 228000
  },
  {
    "County": "Whitman",
    "pop_2020": 50480
  },
  {
    "County": "Yakima",
    "pop_2020": 258200
  }
]
